import { r as registerInstance, h } from './index-5faac9d7.js';
import { a6 as CATEGORY } from './currency-7be6806c.js';

const PesAppSprykerCategoryListing = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.host = undefined;
    this.showBreadcrumbs = undefined;
    this.categoryAllData = null;
    this.categoryId = undefined;
    this.showDocuments = true;
    this.enableCommerceConnector = true;
    this.showBuyOnline = true;
    this.productCtas = undefined;
    this.showCompare = true;
    this.recentlyViewedProducts = undefined;
    this.isPBS = false;
    this.searchParams = {};
    this.countryCode = undefined;
    this.languageCode = undefined;
    this.storageName = '';
    this.currentPageStorageKey = '';
  }
  componentWillLoad() {
    this.storageName = `${this.host}${this.countryCode}/${this.languageCode}/`;
    this.currentPageStorageKey = `${CATEGORY}/${this.categoryId}`;
  }
  render() {
    var _a, _b, _c;
    const { hmcBanner } = this.categoryAllData.listingInfo;
    const { analyticsPageData } = this.categoryAllData.metaTags;
    return (h("pes-app-category-subcategory-listing", { host: this.host, showBreadcrumbs: this.showBreadcrumbs, categoryOrSubcategoryId: this.categoryId, showDocuments: this.showDocuments, enableCommerceConnector: this.enableCommerceConnector, showBuyOnline: this.showBuyOnline, showCompare: this.showCompare, breadcrumbs: (_a = this.categoryAllData) === null || _a === void 0 ? void 0 : _a.breadcrumbs, descriptionInfo: (_b = this.categoryAllData) === null || _b === void 0 ? void 0 : _b.descriptionInfo, listingInfo: (_c = this.categoryAllData) === null || _c === void 0 ? void 0 : _c.listingInfo, hmcBannerInfo: hmcBanner, searchParams: this.searchParams, recentlyViewedProducts: this.recentlyViewedProducts, isSubcategoryPage: false, isPBS: this.isPBS, productCtas: this.productCtas, storageName: this.storageName, currentPageStorageKey: this.currentPageStorageKey, analyticsPageData: analyticsPageData }));
  }
};

export { PesAppSprykerCategoryListing as pes_app_spryker_category_listing };
